<div
  role="menu"
  [id]="id"
  [attr.aria-labelledby]="id"
  data-test="dropdown-list"
  *ngIf="options?.length"
>
  <flo-link class="subhead" *ngFor="let option of options; trackBy: trackById;" [link]="option"></flo-link>
</div>
